//Base_URL
export const BASE_URL = "https://api.nanny-line.com";
// export const BASE_URL = "http://localhost:8000";

// Auth
export const userLoginApi = "/v1/common/login"
export const userSignUpApi = "/v1/common/signUp"
export const verifyOtpApi = "/v1/common/otpVerifications"
export const getNaniesByCategory = "/v1/user/getNanniesByCategory?categoryId=681b6aa0377c79403c43bf40&limit=10&skip=0&address=mohali,punjab&latitude=30.65757&longitude=76.54545&date=07/08/2025&time=05:00%20AM&numberOfHours=1"

//Api Name
export const OngoingUserApi = "/v1/user/getMyBookings?type=0"
export const upcommingUserApi = "/v1/user/getNanniesBookings"
export const UserprofileApi = "/v1/user/profile"
export const UserEditProfileApi = "/v1/user/updateProfile"
export const AddratingbookingApi = "/v1/user/addRatingToBooking"
export const addressUserApi = "/v1/user/getAddresses"

//Nanny Api's
export const profileNanny = "/v1/nanny/profile"
export const updateProfileNanny = "/v1/nanny/updateProfile"
export const updateBookingStatusApi = "/v1/nanny/updateBookingStatus"
export const DocumentsnannyApi = "/v1/nanny/getDocuments"
export const getAllCategoriesApi = "/v1/nanny/getAllCategories?skip=0&limit=10&type=0"
export const uploadDocumentsApi = "/v1/nanny/uploadDocuments"
export const gettimingApi = "/v1/nanny/getTimings"
export const updateTimingsApi = "/v1/nanny/updateTimings"
export const deleteTimingsApi = "/v1/nanny/deleteTimings"
export const NannyBookingApi = "/v1/nanny/getMyBookings"
export const UpdateNannyCatgories = "/v1/nanny/updateNannyCatgories"
export const categoriesApi = "/v1/user/categories"
export const categoryDetailsApi = "/v1/admin/categories/detail"

//Common Api's
export const changePassword = "/v1/common/changePassword"
export const uploadFileApi = "/v1/upload"
export const chathistoryApi = "/v1/common/getChatHistory"
